const formatYearMonth = (stamp) => {
    const year = getYear(stamp);
    const month = getMonth(stamp);

    return `${month} ${year}`;
};

function getYear(date, year) {
    try {
        const Cdate = new Date(date);

        return Cdate.getUTCFullYear() || year;
    } catch (e) {
        return null;
    }
}

function getMonth(date, month) {
    try {
        const formatter = new Intl.DateTimeFormat('en', { month: 'long' });
        const finalMonth = formatter.format(new Date(date || null));

        return finalMonth || month;
    } catch (e) {
        console.log('errored', e);

        return null;
    }
}

module.exports = {
    formatYearMonth,
    getYear,
    getMonth,
};
